import { ListItem } from "@mui/material";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import HNSColors from "../../../components/ui library/HNSColors";
import DropdownMenu from "../../ui library/components/menus/DropdownMenu";
import Svg from "../../ui library/components/svgs/standard/svg";

import SideBarMenuItem from "./SideBarMenuItem";

const SideBarList = ({
  BUTTON_TYPE,
  Menu,
  index,
  activeRoute,
  sideBarIsOpen,
  setSideBarIsOpen,
  closeDropdowns,
  triggerDropdown,
}) => {
  const { pathname } = useLocation();
  const isDropdown = Menu.type === BUTTON_TYPE.DROPDOWN;
  const isActiveURL = Menu.key === activeRoute;

  const isActiveDropdownURL = useMemo(() => {
    return Menu?.menuItems?.some((item) => item.url === pathname);
  }, [Menu.menuItems, pathname]);

  return (
    <ListItem key={index} className={isDropdown ? `flex-col` : ""}>
      {isDropdown ? (
        <DropdownMenu
          Menu={Menu}
          icon={
            <Svg
              name={Menu.icon}
              sx={{ height: "24px", width: "24px" }}
              color={isActiveDropdownURL ? HNSColors.primary[600] : HNSColors.neutrals[300]}
            />
          }
          sideBarIsOpen={sideBarIsOpen}
          setSideBarIsOpen={setSideBarIsOpen}
          closeDropdowns={closeDropdowns}
          isActiveDropdownURL={isActiveDropdownURL}
          triggerDropdown={triggerDropdown}
        />
      ) : (
        <SideBarMenuItem
          Menu={Menu}
          icon={
            <Svg
              name={Menu.icon}
              color={isActiveURL ? HNSColors.primary[600] : HNSColors.neutrals[300]}
            />
          }
          sideBarIsOpen={sideBarIsOpen}
          setSideBarIsOpen={setSideBarIsOpen}
          isActiveURL={isActiveURL}
          triggerDropdown={triggerDropdown}
        />
      )}
    </ListItem>
  );
};

export default SideBarList;
